import { ButtonBase, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AboutModal from './AboutModal';
import IDKeys from '../constants/idKeys';
import { ReactComponent as VeroSourceLogo } from '../graphics/verosource-logo-grey.svg';

/**
 * The default footer for the application. Wraps and adds content to the provided body component.
 * @param {object} props Props accepted by the component.
 * @param {object} props.children Component to display as body content.
 * @returns {React.FunctionComponent} React element that contains the footer.
 */
function PageFooter({ children }) {
  const [translate] = useTranslation();
  const [aboutOpen, setAboutOpen] = useState(false);

  return (
    <Stack
      sx={{
        alignItems: 'center',
        paddingX: 2,
        paddingBottom: 2,
        gap: 2,
      }}
    >
      <React.Fragment id={`${IDKeys.FOOTER}Content`}>
        {children}
        <Typography variant="h_xxs" textAlign="center">
          {translate('closeBrowser')}
        </Typography>
      </React.Fragment>
      <ButtonBase
        onClick={() => setAboutOpen(true)}
        sx={{ p: 1, borderRadius: 1 }}
      >
        <VeroSourceLogo
          id={`${IDKeys.FOOTER}VeroSourceLogo`}
          width="110px"
          height="33px"
        />
      </ButtonBase>
      <AboutModal open={aboutOpen} onClose={() => setAboutOpen(false)} />
    </Stack>
  );
}

export default PageFooter;
